import { useEffect, useRef, useState, RefObject } from 'react'
import navLogo from '../../assets/images/nav-logo.svg'
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { isUserToken } from '../../utils';
import { Link, useHistory } from 'react-router-dom';
import { SUPPORTED_LANG, USER_TOKEN_KEY, frontendRoutes } from '../../Constants/constants';
import { Button } from '../Button/Button';
import { GET_BUILDER_ID_SUCCESS, GET_PROPERTY_SUCCESS, SEARCH_COMMUNITY_SUCCESS } from '../../redux/types/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import locationIcon from '../../assets/images/icn-location.svg'
import { BuilderSettings } from '../../redux/types/builders';
import { useTranslation } from "react-i18next";

type MenuList = {
    title: string,
    url: string,
    isAuthenticated: boolean,
    icon: string,
    subMenu: subMenuType[],
    isExternalLink: boolean,
}

interface MenuAction {
    type: 'logout';
}

type subMenuType = {
    title: string,
    url: string,
    action?: MenuAction,
}

interface MenuIconProps {
    isOpen: boolean,
    toggleMenu: () => void,
    triggerRef: RefObject<HTMLButtonElement>
}

const MenuIcon = ({ isOpen, toggleMenu, triggerRef }: MenuIconProps) => {
    return (
        <button type='button' ref={triggerRef} className='mobile-menu-icon'
            aria-label='Menu' aria-expanded={isOpen} aria-controls='mobile-navigation'
            onClick={toggleMenu}>
            <span aria-hidden="true" className={`${isOpen ? 'close-menu bg-dark' : ''} menu-bar `}></span>
            <span aria-hidden="true" style={{ opacity: isOpen ? 0 : 1 }} className="menu-bar"></span>
            <span aria-hidden="true" className={`${isOpen ? 'close-menu-reverse bg-dark' : ''} menu-bar `}></span>
        </button>
    )
}

const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();

    const changeLanguage = (lng: string) => {
      i18n.changeLanguage(lng);
    };

    const builderSettings: BuilderSettings = useSelector((state: any) => state.builder.settings);   

    const mapLang = {
        [SUPPORTED_LANG.EN]: '🇺🇸 ' + t('english'),
        [SUPPORTED_LANG.ES]: '🇪🇸 ' + t('spanish'),
    }

    return (
      <Dropdown className='language-dropdown'>
        <Dropdown.Toggle variant="none" className='nav-link toggle-dropdown'>
           {mapLang[i18n.language] || i18n.language}
        </Dropdown.Toggle>
  
        <Dropdown.Menu className="fixed-dropdown-menu">
            <Dropdown.Item 
                className="custom-dropdown-item"
                style={{ "--active-color": builderSettings.primary_color || "#f8f9fa" } as React.CSSProperties}
                onClick={() => changeLanguage(SUPPORTED_LANG.EN)}
            >
                {mapLang[SUPPORTED_LANG.EN]}
            </Dropdown.Item>
          <Dropdown.Item
                className="custom-dropdown-item"
                style={{ "--active-color": builderSettings.primary_color || "#f8f9fa" } as React.CSSProperties}
                onClick={() => changeLanguage(SUPPORTED_LANG.ES)}
          >
                {mapLang[SUPPORTED_LANG.ES]}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

const MobileMenu = ({ builderImage }: any) => {
    const { t } = useTranslation();
    const builder_name: string = localStorage.getItem('builder_name') || 'static_builder';
    const history = useHistory();
    const dispatch = useDispatch()
    
    const menuRef = useRef<HTMLDivElement | null>(null)
    const menuTriggerRef = useRef<HTMLButtonElement>(null);
    const menuPanelRef = useRef<HTMLElement>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isOpenSubMenu, setIsOpenSubMenu] = useState<number | null>(null);

    useEffect(() => {
        if (!isOpen) return;
        menuPanelRef.current?.querySelector<HTMLElement>('a[href], button:not([disabled]), [tabindex="0"]')?.focus();
        const onEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
                setIsOpenSubMenu(null);
                menuTriggerRef.current?.focus();
            }
        };
        document.addEventListener('keydown', onEscape);
        return () => document.removeEventListener('keydown', onEscape);
    }, [isOpen]);


    const handleClick = ( {url, subMenu}: MenuList, index: number) => {

        if (url) {
            setIsOpen(false);
            setIsOpenSubMenu(null);
            history.push(url);
        } else if (subMenu.length > 0) {
            isOpenSubMenu === index ? setIsOpenSubMenu(null) : setIsOpenSubMenu(index)
        }
    }
    
      useEffect(() => {
        const closeMenu = (e: MouseEvent) => {
            e.stopPropagation()
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setIsOpenSubMenu(null);
            }
          };

        document.addEventListener('mouseup', closeMenu);
    
        return () => {
          document.removeEventListener('mouseup', closeMenu);
        };
      }, []);

    const onClickSubMenu = (url: string, action?: MenuAction) => {
        if (action?.type === 'logout') {
            logout(url)
        } else {
            setIsOpenSubMenu(null)
            setIsOpen(false);
            history.push(url)
        }
      }

      const logout = (url: string) => {
        setIsOpenSubMenu(null)
        setIsOpen(false);
        dispatch({
            type: SEARCH_COMMUNITY_SUCCESS,
            payload: null,
          });
        dispatch({
            type: GET_PROPERTY_SUCCESS,
            payload: null,
          });
        dispatch({
            type: GET_BUILDER_ID_SUCCESS,
            payload: null,
          });
        localStorage.removeItem(USER_TOKEN_KEY);
        history.push(url)
      }

    const menuList: MenuList[] = [
        // {
        //     title: 'Map',
        //     url: `/${builder_name}/map`,
        //     isAuthenticated: false,
        //     icon: '',
        //     subMenu: [],
        //     isExternalLink: false
        // },
        // {
        //     title: 'Map',
        //     url: `/${builder_name}/map`,
        //     isAuthenticated: true,
        //     icon: '',
        //     subMenu: [],
        //     isExternalLink: false
        // },
        {
            title: t('how_it_works'),
            url: `/${builder_name}`,
            isAuthenticated: false,
            icon: '',
            subMenu: [],
            isExternalLink: false
        },
        {
            title: t('help'),
            url: 'https://nternow.freshdesk.com/support/solutions/articles/63000259067-self-tour-faq-',
            isAuthenticated: false,
            icon: '',
            subMenu: [],
            isExternalLink: true
        },
        {
            title: t('book_a_tour'),
            url: `/${builder_name}`,
            isAuthenticated: true,
            icon: locationIcon,
            subMenu: [],
            isExternalLink: false
        },
        // {
        //     title: 'Map',
        //     url: frontendRoutes.propertyMap(builder_name).path,
        //     isAuthenticated: true,
        //     icon: locationIcon,
        //     subMenu: [],
        //     isExternalLink: false
        // },
        // {
        //     title: 'Map',
        //     url: `/${builder_name}/map`,
        //     isAuthenticated: true,
        //     icon: '',
        //     subMenu: [],
        //     isExternalLink: false
        // },
        {
            title: t('tours'),
            url: '',
            isAuthenticated: true,
            icon: '',
            subMenu: [
                {
                    title: t('upcoming_tours'),
                    url: frontendRoutes.upcomingTours(builder_name).path,
                },
                {
                    title: t('previous_tours'),
                    url: frontendRoutes.previousTours(builder_name).path,
                },
            ],
            isExternalLink: false
        },
        {
            title: t('support'),
            url: 'tel:+1-844-531-1283',
            isAuthenticated: true,
            icon: '',
            subMenu: [],
            isExternalLink: true
        },
        {
            title: t('my_profile'),
            url: '',
            isAuthenticated: true,
            icon: '',
            subMenu: [
                {
                    title: t('edit_profile'),
                    url: frontendRoutes.editProfile(builder_name).path,
                },
                {
                    title: t('sign_out'),
                    url: `/${builder_name}`,
                    action: {
                        type: 'logout',
                    }
                },
            ],
            isExternalLink: false
        },
    ]

    return (
        <div className={`mobile-menu-container ${isOpen && 'mobile-menu-fixed'}`}>
            <MenuIcon isOpen={isOpen} triggerRef={menuTriggerRef} toggleMenu={() => { setIsOpen(prev => !prev); setIsOpenSubMenu(null); }} />
            <Link to={`/${builder_name}`}>
                <Navbar.Brand >
                    <img src={builderImage || navLogo} alt={t('header_logo')} className='logo' />
                </Navbar.Brand>
            </Link>

            {/* Mobile Menu */}
            <section id="mobile-navigation" ref={menuPanelRef} aria-hidden={!isOpen} className={`mobile-side-menu ${isOpen ? '' : 'close-sidebar'}`}>
                <Nav className='top-nav' ref={menuRef}>
                    {menuList.filter(menu => isUserToken() ? menu.isAuthenticated : !menu.isAuthenticated).map((menu, index) =>
                        <div className='nav-item' key={menu.url || menu.subMenu.map(item => item.url).join('|')} >
                            {menu.isExternalLink ?
                                <a href={menu.url} target="_blank" className='nav-link' rel="noreferrer" >{menu.title}</a>    
                                :
                                <button
                                    type="button"
                                    className="nav-link"
                                    aria-expanded={menu.subMenu.length > 0 ? isOpenSubMenu === index : undefined}
                                    onClick={() => handleClick(menu, index)}
                                >
                                    {menu.icon && <img src={menu.icon} alt="" style={{ width: '16px', marginRight: '1px',  }} />}
                                    {menu.title}
                                    {menu.subMenu.length > 0 &&
                                    <span className={`arrow-icon ${isOpenSubMenu === index ? 'arrow-up-animate' : ''}`} aria-hidden="true">&#8963;</span> }
                                </button>
                            }

                            {(isOpenSubMenu === index && menu.subMenu.length > 0) &&
                                <Nav className='sub-nav'>
                                    {menu.subMenu.map(nav =>
                                        <button
                                            key={nav.url}
                                            type="button"
                                            onClick={event => {
                                                event.stopPropagation();
                                                onClickSubMenu(nav.url, nav.action);
                                            }}
                                        >
                                            {nav.title}
                                        </button>
                                    )}
                                </Nav>
                             }
                        </div>
                    )}
                    {
                        process.env.REACT_APP_SUPPORT_MULTI_LANGUAGE === "true" &&
                        <div className='nav-item'>
                            <LanguageSwitcher/>
                        </div>
                    }
                    {!isUserToken() && 
                    <div className='nav-item'>
                        <Button 
                        type='button' 
                        onClick={() => history.push(frontendRoutes.signIn(builder_name).path)} 
                        className='signIn-btn button w-auto px-4'
                        style={{ boxShadow: '2px 6px 20px 2px rgba(0, 0, 0, 0.32)' }}
                        >
                            {t('sign_in')}
                        </Button>

                        <button
                            type="button"
                            className="signIn-text nav-link py-3 px-4"
                            onClick={() => {
                                setIsOpen(false);
                                history.push(frontendRoutes.signIn(builder_name).path);
                            }}
                        >
                            {t('sign_in')}
                        </button>
                    </div>
                    }
                   
                </Nav>
                <Nav className='bottom-nav'>
                    <Nav.Link className='py-3 px-4'>{t('privacy_policy')}</Nav.Link> 
                    <Nav.Link className='py-3 px-4'>{t('terms_legal')}</Nav.Link>
                    <Nav.Link className='py-3 px-4'>{t('housing_opportunities')}</Nav.Link>
                </Nav>
            </section>
        </div>
    )
}

export default MobileMenu